module.exports = __webpack_public_path__ + "static/img/image161.694af11b.png";